import React, { createContext, useEffect, useState } from 'react';

// Playback position (seconds) of the recording, for the transcript to follow.
export const CallPlaybackContext = createContext(0);

const VOICEMAIL_MAX_SECONDS = 7;
// Some browsers (e.g. iOS Safari) don't preload metadata; show the player
// anyway if the duration hasn't arrived by then.
const METADATA_TIMEOUT_MS = 4000;

export default function CallRecording({ src, children }) {
    const [duration, setDuration] = useState(null);
    const [expanded, setExpanded] = useState(false);
    const [timedOut, setTimedOut] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);

    useEffect(() => {
        const id = setTimeout(() => setTimedOut(true), METADATA_TIMEOUT_MS);
        return () => clearTimeout(id);
    }, []);

    const isShort = duration !== null && Math.floor(duration) <= VOICEMAIL_MAX_SECONDS;
    const showCall = expanded || (duration !== null ? !isShort : timedOut);

    return (
        <>
            {isShort && !expanded && (
                <button
                    type="button"
                    onClick={() => setExpanded(true)}
                    style={{
                        display: 'flex', alignItems: 'center', gap: '6px',
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(255,255,255,0.15)',
                        borderRadius: '6px',
                        color: '#B1B1B1',
                        fontSize: '13px',
                        padding: '6px 12px',
                        cursor: 'pointer',
                    }}
                >
                    <i className="pi pi-phone" style={{ fontSize: 12 }} />
                    Went to voicemail
                </button>
            )}
            <audio
                style={{ width: '100%', display: showCall ? undefined : 'none' }}
                controls
                preload="metadata"
                onLoadedMetadata={(e) => {
                    const d = e.currentTarget.duration;
                    setDuration(Number.isFinite(d) ? d : Infinity);
                }}
                onTimeUpdate={(e) => setCurrentTime(e.currentTarget.currentTime)}
            >
                <source src={src} type="audio/mpeg" onError={() => setDuration(Infinity)} />
            </audio>
            {showCall && (
                <CallPlaybackContext.Provider value={currentTime}>
                    {children}
                </CallPlaybackContext.Provider>
            )}
        </>
    );
}
